<div class="container">
    <div class="row mx-0 mt-5 gx-3">
        <h2 class="fw-bold text-center">Solar PV</h2>
        <div class="col-md-6 order-md-1 order-2">
            <img src="assets/images/solarpaneltop.svg" alt="solarpanel" class="img-top">
        </div>
        <div class="col-md-6 align-self-center mt-4 p-lg-4 order-md-2 order-1">
            <h3 class="fw-bold text-primary text-center fs-4">Request Quotes</h3>
            <form class="row g-3" name="solarPanelForm" #formRef="ngForm" (ngSubmit)="onSubmit(formRef)"
                [formGroup]="solarPanelForm" novalidate autocomplete="off">
                <div class="col-md-6">
                    <mat-label>Title</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput type="text" formControlName="title" maxlength="100" required />
                        <mat-error *ngIf="solarPanelForm.get('title')!.hasError('required')">
                            Title is required
                        </mat-error>
                        <mat-error
                            *ngIf="!solarPanelForm.get('title')!.hasError('required') && solarPanelForm.get('title')!.hasError('invalidName')">
                            Please enter a valid title
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-label>First Name</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput type="text" formControlName="firstName" maxlength="50" required />
                        <mat-error *ngIf="solarPanelForm.get('firstName')!.hasError('required')">
                            First Name is required
                        </mat-error>
                        <mat-error
                            *ngIf="!solarPanelForm.get('firstName')!.hasError('required') && solarPanelForm.get('firstName')!.hasError('invalidName')">
                            Please enter a valid first name
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-label>Last Name</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput type="text" formControlName="lastName" maxlength="50" required />
                        <mat-error *ngIf="solarPanelForm.get('lastName')!.hasError('required')">
                            Last Name is required
                        </mat-error>
                        <mat-error
                            *ngIf="!solarPanelForm.get('lastName')!.hasError('required') && solarPanelForm.get('lastName')!.hasError('invalidName')">
                            Please enter a valid last name
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-label>Email</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput type="text" formControlName="email" maxlength="50" required />
                        <mat-error *ngIf="solarPanelForm.get('email')!.hasError('required')">
                            Email is required
                        </mat-error>
                        <mat-error
                            *ngIf="!solarPanelForm.get('email')!.hasError('required') && solarPanelForm.get('email')!.hasError('invalidEmail')">
                            Please enter a valid email
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-label>Mobile No.</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput type="text" formControlName="mobileNumber" maxlength="12" required />
                        <mat-error *ngIf="solarPanelForm.get('mobileNumber')!.hasError('required')">
                            Mobile no. is required
                        </mat-error>
                        <mat-error
                        *ngIf="!solarPanelForm.get('mobileNumber')!.hasError('required') && solarPanelForm.get('mobileNumber')!.hasError('invalidPhone')">
                        Please enter a valid mobile number
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-label>Town</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput type="text" formControlName="town" maxlength="100" required />
                        <mat-error *ngIf="solarPanelForm.get('town')!.hasError('required')">
                            Town is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-label>Street Name</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput type="text" formControlName="streetName" maxlength="100" required />
                        <mat-error *ngIf="solarPanelForm.get('streetName')!.hasError('required')">
                            Street Name is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-label>House Number</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput type="text" formControlName="houseNumber" maxlength="100" required />
                        <mat-error *ngIf="solarPanelForm.get('houseNumber')!.hasError('required')">
                            House Number is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-label>Post Code</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput type="text" formControlName="postcode" maxlength="10" required />
                        <mat-error *ngIf="solarPanelForm.get('postcode')!.hasError('required')">
                            Post Code is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-label>Quantity of Panels</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-select formControlName="quantityOfPanels" required>
                            <mat-option *ngFor="let in of counter(77) ;let i = index" [value]="i+4">{{i+4}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="solarPanelForm.get('quantityOfPanels')!.hasError('required')">
                            Quantity of Panels is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-label>Roof Type</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-select formControlName="roofType" required>
                            <mat-option *ngFor="let rT of roofTypeArr" [value]="rT.v">{{rT.n}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="solarPanelForm.get('roofType')!.hasError('required')">
                            Roof Type is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-label>Scaffold Required</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-select formControlName="scaffold" required>
                            <mat-option *ngFor="let bln of boolArr" [value]="bln.v">{{bln.n}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="solarPanelForm.get('scaffold')!.hasError('required')">
                            Scaffold is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-label>Storage Size</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-select formControlName="storageSize" required>
                            <mat-option *ngFor="let storg of storageSizeArr" [value]="storg">{{storg}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="solarPanelForm.get('storageSize')!.hasError('required')">
                            Storage Size is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-12 mt-3 text-end">
                    <button mat-flat-button color="primary" fxShow="false" fxShow.gt-sm type="submit"
                        [disabled]="solarPanelForm!.invalid || disabled">
                        <app-loader [type]="'btn'" *ngIf="disabled"></app-loader>
                        Submit
                    </button>
                </div>
            </form>
        </div>
    </div>
    <div class="row mx-0 solar-save my-5">
        <div class="col-md-4 mb-3 text-center">
            <img src="assets/images/solarpanelicon1.svg" alt="icon" class="mb-2 icon">
            <h3 class="fw-bold mb-1 fs-5">Save Time</h3>
            <p class="mx-auto">Get up to 4 quotes from our selected suppliers by filling in only 1 form</p>
        </div>
        <div class="col-md-4 mb-3 text-center">
            <img src="assets/images/solarpanelicon2.svg" alt="icon" class="mb-2 icon">
            <h3 class="fw-bold mb-1 fs-5">Save Money</h3>
            <p class="mx-auto">Save money by comparing quotes and choosing the most competitive offer</p>
        </div>
        <div class="col-md-4 mb-3 text-center">
            <img src="assets/images/solarpanelicon3.svg" alt="icon" class="mb-2 icon">
            <h3 class="fw-bold mb-1 fs-5">Free and No Obligation</h3>
            <p class="mx-auto">Our service is 100% free and with no obligation</p>
        </div>
    </div>
    <div class="row mx-0 py-md-5 py-4">
        <div class="col-md-7 align-self-center">
            <h1 class="fw-bold fs-3 mb-4">Solar PV</h1>
            <ul>
                <li class="mb-3">The sun provides an abundant source of clean, renewable energy. This can be converted
                    into electricity using solar photovoltaic panels, usually referred to as ‘solar PV’.</li>
                <li>Electricity generated by a domestic solar PV system can be used to power your home, leading to
                    savings on your electricity bills.</li>
            </ul>
        </div>
        <div class="col-md-5 align-self-center mb-md-0 mb-5">
            <img src="assets/images/solarPanel-2.svg" alt="" class="img-fluid">
        </div>
    </div>
    <div class="row mx-0 py-md-5 py-4">
        <div class="col-md-5 align-self-center mb-md-0 mb-5 order-md-1 order-2">
            <img src="assets/images/solarPanel-3.svg" alt="" class="img-fluid">
        </div>
        <div class="col-md-7 align-self-center order-md-2 order-1">
            <h1 class="fw-bold fs-3 mb-4">How does it work?</h1>
            <p>Solar PV systems turn sunlight into electricity through the ‘solar cells’ they contain. These cells are
                made from thin layers of a ‘semiconductor’ material (traditionally silicon) between layers of glass.
                Electricity leaves the panel as direct current (DC) and passes through an inverter that converts it to
                240V alternating current (AC) so that it can be used in your home.</p>
        </div>
    </div>
    <div class="row mx-0 py-md-5 py-4">
        <div class="col-md-7 align-self-center">
            <h1 class="fw-bold fs-3 mb-4">Why there’s never been a
                better time to go solar!</h1>
            <p>Huge increases in energy cost are hitting households harder than ever and they are set to rise even
                further by 50-60% in October, just before winter hits us.</p>
            <p>As living costs continue to rise, the burden of even more expensive energy will force many families to
                compromise. There is a solution.</p>
            <ul>
                <li>Reducing your household electric bill and your reliance on the national grid enables you to offset
                    other cost of living increases.</li>
                <li>Renewable clean power that is available every day of the year, even on cloudiest days, solar
                    produces some power no matter where you are in the UK.</li>
                <li>Return on investment, unlike paying for utility bills as well as adding considerable value to the
                    property and its efficiency rating.</li>
                <li>Falling costs, improved technology and efficiency has made solar panels more affordable than ever.
                </li>
            </ul>
        </div>
        <div class="col-md-5 align-self-center mb-md-0 mb-5">
            <img src="assets/images/solarPanel-4.svg" alt="" class="img-fluid">
        </div>
    </div>

</div>